import React, { useMemo } from 'react';
import type { Theme } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { CamundaFields } from '@forvalter/utils/CamundaUtils';
import type { Aktivitet } from '@klp/formgenerator/interfaces';
import { useTranslation } from 'react-i18next';

const styles = (theme: Theme) => ({
    textField: {
        backgroundColor: theme.palette.background.paper,
    },
});

type TildelKommentarFieldProps = {
    activity: Aktivitet;
    value: string;
    maxLength: number;
    onChange: (value: string) => void;
};

export const TildelKommentarField: React.FC<TildelKommentarFieldProps> = ({
    activity,
    value,
    maxLength,
    onChange,
}) => {
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();

    const label = useMemo(
        () =>
            `${t(
                `leverandor.${CamundaFields.TILDEL_KOMMENTARER}.field.label`,
            )} (${t('general.charactersRemaining', { count: maxLength - value.length })})`,
        [t, maxLength, value.length],
    );
    const placeholder = useMemo(
        () =>
            t(
                `leverandor.${CamundaFields.TILDEL_KOMMENTARER}.field.placeholder`,
            ),
        [t],
    );

    if (!activity?.id) return null;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <TextField
            variant="outlined"
            id={CamundaFields.TILDEL_KOMMENTARER}
            label={label}
            placeholder={placeholder}
            type="text"
            fullWidth={true}
            multiline={true}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{ maxLength }}
            value={value}
            onChange={handleChange}
            className={classes.textField}
        />
    );
};
